import type { Employee } from '@momentum/types';
import { cn } from '@/shared/utils/utils';
import { getFullName } from '@/shared/utils/employee-utils';

interface ParticipantAvatarProps {
  employee: Employee;
  size: 'sm' | 'md' | 'lg';
}

const SIZE_CLASS: Record<ParticipantAvatarProps['size'], string> = {
  sm: 'w-6 h-6 text-[10px]',
  md: 'w-8 h-8 text-xs',
  lg: 'w-10 h-10 text-sm',
};

export function ParticipantAvatar({ employee, size }: ParticipantAvatarProps) {
  const dimensions = SIZE_CLASS[size];
  const { firstName, lastName, imageUrl } = employee.personalInfo;
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  const fullName = getFullName(employee) ?? '';

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={fullName}
        className={cn(
          'rounded-full object-cover ring-2 ring-white border border-slate-200',
          dimensions
        )}
      />
    );
  }

  return (
    <span
      className={cn(
        'rounded-full bg-slate-200 text-slate-600 font-semibold inline-flex items-center justify-center ring-2 ring-white border border-slate-200',
        dimensions
      )}
      aria-label={fullName}
    >
      {initials}
    </span>
  );
}
